// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"c672ef65","419":"663e2134","563":"58d9f533","942":"432e20b8"}[chunkId] + ".chunk.js";
};